import { useMemo } from 'react';

// Utils
import { getJobTitleLabel } from '@/utils';

// Stores
import {
  useCertifications,
  useCurrentTemplate,
  useEducation,
  usePersonalInfo,
  useSkills,
  useWorkJourney,
} from '@shared/stores';

// Components
import { CV_TEMPLATES } from '../components/template';

const useResumeData = () => {
  const info = usePersonalInfo();
  const journeyList = useWorkJourney();
  const technicalSkillList = useSkills();
  const educationList = useEducation();
  const certificationList = useCertifications();
  const templateId = useCurrentTemplate();

  const Template = CV_TEMPLATES.find(
    (template) => template.id === templateId,
  )?.component;

  const resumeData = useMemo(
    () => ({
      info: {
        ...info,
        title: getJobTitleLabel(info.title || ''),
      },
      journeys: journeyList,
      educations: educationList,
      technicalSkills: technicalSkillList,
      certs: certificationList,
      _timestamp: Date.now(),
    }),
    [info, journeyList, technicalSkillList, educationList, certificationList],
  );

  return { Template, resumeData, templateId };
};

export default useResumeData;
